<template>
	<CommonHeader class="main_head_block">
		<template v-slot:header>

			<span class="module_heading">DSP Campaign Tagging</span>

			<div class="sel_fil_wrap one">
				<multiselect
					v-model="selectedAdvertiser"
					:options="[{name:'All Advertisers', value:undefined}, ...advertisersList]"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="name"
					track-by="value"
					open-direction="bottom"
					:taggable="false"
                    placeholder="All Advertisers"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					selectedLabel = ""
					@select = "selectAdvertiser($event)"
					@remove = "removeAdvertiser()"
					/>
			</div>

			<div class="adv_fil_wrap">
				<DspFilter style="" v-if="true" :profileTags="tagsList"/>
			</div>

			<div class="head_search">
				<object data='assets/img/search.svg' style="height:18px;width:18px;margin-left:5px;"></object>
			</div>
			<div class="head_search_inp">
				 <input type="search" id="search" class="search" v-model="searchFilterString"  placeholder="Client Name" @keyup.enter="applyDspSearchFilter()" style = "border: none;outline:none;padding: 7px 0px 5px 10px;" autocomplete = "off"/>
			</div>
		</template>
	</CommonHeader>
</template>

<script>
import Multiselect from "vue-multiselect";
import CommonHeader from "@/components/CommonHeader.vue"
import DspFilter from "@/components/dsp-tags/DspFilter.vue";


export default {
  name: "DspListFilter",
  components:{
	  Multiselect,
	  CommonHeader,
	  DspFilter
  },
  data() {
    return {
        tagTypeFilterOptions:[
			{ name: `Awareness`, value: `Awareness` },
			{ name: `brand`, value: `brand` },
			{ name: `Consideration`, value: `Consideration` },
			{ name: `Conversion`, value: `Conversion` },
			{ name: `Cross-sell`, value: `Cross-sell` },
			{ name: `Loyalty`, value: `Loyalty` },
			{ name: `Prospecting`, value: `Prospecting` },
			{ name: `Purchase`, value: `Purchase` },
			{ name: `Retargeting`, value: `Retargeting` },
			{ name: `Retention`, value: `Retention` },
			{ name: `Trial`, value: `Trial` }
        ],
		tagsList: []
    }
  },
  mounted(){
	  this.$store.dispatch("getDspAdvertisers")
	  this.getTagOptions()
	  this.selectAdvertiser({})
  },
  methods: {
      applyDspSearchFilter(data) {
		const params = {
			q: this.$store.state.searchFilterString,
			advertiser_id: this.selectedAdvertiser.value
		}
		this.$store.dispatch("getAllDsp",params)
      },
      selectAdvertiser(data) {
		const params = {
			tag_type: (!this.$store.state.dspTagType || this.$store.state.dspTagType.name=='All Types')?'':this.$store.state.dspTagType.name,
			advertiser_id: data.value,
			tags: this.$store.state.campaign.advanceFilter.tags
		}
		console.log('selectAdvertiser:',data)
		//this.$store.commit("updateDspAdvertisers",data)
		this.$store.dispatch("getAllDsp",params).then(
			this.getTagOptions(this.selectedAdvertiser.value)
		)
      },
	  removeAdvertiser(data) {
		const params = {
			// tag_type: (!this.$store.state.dspTagType || this.$store.state.dspTagType.name=='All Types')?'':this.$store.state.dspTagType.name,
			// advertiser_id: data.value
		}
		//this.$store.commit("updateDspAdvertisers",data)
		this.$store.dispatch("getAllDsp",params).then(
			this.getTagOptions()
		)
      },
      selectTagType(data) {
		const params = {
			tag_type: data.value,
			advertiser_id: this.selectedAdvertiser.value
		}
		this.$store.dispatch("getAllDsp",params)
      },
      removeTagType(data) {
		const params = {
			tag_type: '',
			advertiser_id: this.selectedAdvertiser.value
		}
		this.$store.dispatch("getAllDsp",params)
      },
	  getTagOptions(data) {
      let vm = this;
      this.$store
        .dispatch("getDspTagOptions", {advertiser_id : data})
        .then((data) => {
          if (data && data.length && data[0].id != "all") {
			  data.unshift({ id: "all", title: "All Tags" });
			  data.unshift({id:"untagged",title:"Untagged"});
			}
        vm.tagsList = data;
        });
	}
  },
  computed: {
    searchFilterString: {
      set(val) {
		if(!val){
			this.$store.state.searchFilterString = val
		}
		else{
			this.$store.state.searchFilterString = val

		}
		this.$store.commit("resetTableFooterFilter");
      },
      get() {
          return this.$store.state.searchFilterString;
      }
    },
	selectedAdvertiser: {
        set(val) {
          this.$store.state.dspAdvertiser = val;
        },
        get() {
          return this.$store.state.dspAdvertiser;
        }
	},
	advertisersList: {
        set(val) {
          this.$store.state.dspAdvertisers = val;
        },
        get() {
          return this.$store.state.dspAdvertisers;
        }
	},
	selectedType: {
        set(val) {
          this.$store.state.dspTagType = val;
        },
        get() {
          return this.$store.state.dspTagType;
		}
	}
	}
}
</script>

<style lang="scss">
.sellerLabel {
	font-weight: bold;
	margin-left: 5px;
	text-align: left;
}
.sellerSelector{
	margin-top: 26px;
	width: 65px;
}
.fil_btn{
	margin-top: 15px;
	margin-left: 15px;
}
.main_head_block{
.head_block{
	margin: 0px;
	padding: 0px; 
	height: 74px
}
.data_notice {
	font-size: larger;
}
.module_heading{
	padding-top:25px;
	height: 29px;
	min-width: 94px;
	color: #000000;
	font-family: Poppins;
	font-size: 21px;
	font-weight: 500;
	letter-spacing: -0.02px;
	line-height: 31px;
}
.add_icon_container{
	height: 43px;
	width: 43px;
	margin-top: 19px;
	margin-bottom: 16px;
	margin-left: 15px;
	padding-left: 2px;
	background-color: #FAFAFA ;
	border-radius: 50%;
	cursor: pointer;
	.icon_add{
		cursor:pointer;
		color: black;
		height: 17px;
		width: 17px;
		opacity: 0.81;
		margin: 13px;
	}
}

.icon_one{
	cursor:pointer;
	color: black;
    height: 18px;
    width: 18px;
    opacity: 0.81;
    margin-top: 32px;
    margin-left: 18px;
}
.icon_two{
	color: black;
    height: 18px;
    width: 18px;
    opacity: 0.81;
    margin-top: 32px;
    margin-left: 6px;
	cursor: pointer;
}
.sel_fil_wrap{
	margin-top:15px;
}
.sel_fil_wrap.one{
	margin-left: 18px;
}
.sel_fil_wrap.two{
	margin-left: 9px;
}
.sel_fil_wrap.three{
	margin-left: 9px;
}
.sel_fil_wrap.four{
	margin-left: 9px;
}
.check_fil_wrap{
	margin-left: 2px;
	margin-top: 34px;
}
.adv_fil_wrap{
	position: absolute;
    right: 21px;
    padding-top: 24px;
}
.head_search{
	height: 43px;
    width: 43px;
    border-radius: 50%;
    background-color: #ffbf3f;
    position: absolute;
    right: 38px;
    top: 15px;
	padding-left: 9px;
    padding-top: 12px;
	.icon{
		padding: 12px 25px 12px 17px;
		height: 18px;
		width: 18px;
		text-align: center;
	}
	.text{
		color: #333;
		font-family: "Nunito Sans";
		font-size: 14px;
		font-weight: 600;
		letter-spacing: -0.03px;
		float: right;
    	margin-right: 10px;	
	}
}
.head_search_inp{
	right: 90px;
    top: 15px;
	position:absolute;
	box-sizing: border-box;
	height: 43px;
	// width: 220px;
	border: 1px solid #979797;
	border-radius: 6px;
	background-color: #FFFFFF;
	margin-left: 10px;
	padding-left:4px;
	padding-right:4px;
	}
}
</style>
